/**
 * localStorage with the failure modes handled once: private mode, quota, disabled storage.
 * Every per-device preference (progress, last-used settings) goes through here.
 */
export function readJson<T>(key: string, fallback: T): T {
  try {
    const raw = localStorage.getItem(key)
    return raw ? (JSON.parse(raw) as T) : fallback
  } catch {
    return fallback
  }
}

export function writeJson(key: string, value: unknown) {
  try {
    localStorage.setItem(key, JSON.stringify(value))
  } catch {
    // storage unavailable — the value just won't persist
  }
}

/** Load/save pair for a per-device setting validated on the way in (bad or old data → fallback). */
export function persisted<T>(
  key: string,
  schema: { safeParse: (v: unknown) => { success: true; data: T } | { success: false } },
  fallback: T,
) {
  return {
    load(): T {
      const parsed = schema.safeParse(readJson<unknown>(key, fallback))
      return parsed.success ? parsed.data : fallback
    },
    save(value: T) {
      writeJson(key, value)
    },
  }
}
